import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.level1,
    margin: "auto 20px",
    flexGrow: "1",
  },
  logo: {
    display: "block",
    padding: "2rem 0 1rem 0",
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: 100,
  },
  contentContainer: {
    display: "flex",
    justifyContent: "center",
    maxWidth: "600px",
    margin: "0 auto",
    paddingBottom: "2rem",
  },
  loadingSpinner: {
    display: "flex",
    justifyContent: "center",
    paddingTop: "1rem",
  },
  formContainer: {
    width: "100%",
  },
  header: {
    textAlign: "center",
    marginBottom: "1.5rem",
  },
  entityName: {
    color: theme.palette.primary?.main,
    fontWeight: "bold",
  },
  title: {
    marginTop: "0.5rem",
  },
  notice: {
    color: theme.palette.text.secondary,
    marginTop: "1rem",
  },
  findReceiptButton: {
    width: "100%",
    fontSize: "1.1rem",
  },
  cardSectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
}));
